import {memo, ReactElement} from 'react';

import {IconButton, IconButtonProps, styled} from '@mui/material';

import {AddToCartDiscountIcon} from 'assets/icons/addToCartIcon';
import {AddToCartNormalIcon} from 'assets/icons/addToCartNormal';
import {AddToCartLoadingIcon} from 'assets/icons/recommendation-icons/add-to-cart-loading-icon';

interface StyledAddToCartButtonProps extends IconButtonProps {
  mode: 'light' | 'dark';
  numberValue?: number;
  icon?: ReactElement;
  productId?: string;
  isMobile?: boolean;
  isLoading?: boolean;
}

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => !(prop == 'mode' || prop == 'numberValue' || prop == 'icon')
})<StyledAddToCartButtonProps>(({numberValue, mode, theme}) => {
  return {
    ...{
      width: 42,
      height: 42,
      ...(numberValue && numberValue > 0
        ? {
            backgroundColor: `${theme.palette.primary.dark}`,
            color: theme.palette.primary.contrastText,
            width: 36,
            height: 36,
            fontSize: 14,
            fontWeight: 700,
            marginRight: theme.spacing(0.5),
            overflow: 'hidden',
            '&:hover,&:focus': {
              backgroundColor: `${theme.palette.primary.dark}`,
              color: theme.palette.primary.contrastText
            },
            ...(mode == 'light'
              ? {
                  border: `1.5px solid ${theme.palette.common.white}`
                }
              : {})
          }
        : {})
    }
  };
});

const ProductAddToCartButton = memo(
  ({
    mode = 'light',
    numberValue,
    icon,
    productId,
    isLoading = false,
    isMobile,
    ...props
  }: StyledAddToCartButtonProps) => {
    const iconSize = isMobile ? 28 : 32;
    return (
      <StyledIconButton
        size="small"
        numberValue={numberValue}
        mode={mode}
        color={mode == 'light' ? 'primary' : 'secondary'}
        data-test-id={`${productId}_btn_add_to_basket`}
        {...props}
      >
        {isLoading ? (
          <AddToCartLoadingIcon />
        ) : icon ? (
          icon
        ) : numberValue ? (
          numberValue
        ) : mode == 'light' ? (
          <AddToCartDiscountIcon width={iconSize} height={iconSize} />
        ) : (
          <AddToCartNormalIcon width={iconSize} height={iconSize} />
        )}
      </StyledIconButton>
    );
  }
);

ProductAddToCartButton.displayName = 'MakroUI.ProductAddToCartButton';

export default ProductAddToCartButton;
